/** Só existe no estado do app — nunca gravar este id no Firestore. */
export const VIRTUAL_GENERAL_CHANNEL_ID = '__frontend_geral__';

export const VIRTUAL_GENERAL_CHANNEL_NAME = 'Geral';

export function isLegacyCommunityPost(postData) {
  const c = postData.channelId;
  return c === undefined || c === null || (typeof c === 'string' && c.trim() === '');
}

export function isVirtualGeneralChannelSelected(selectedChannelId) {
  return selectedChannelId === VIRTUAL_GENERAL_CHANNEL_ID;
}
